module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/ellipsis-h-30fc3bdc738120178ef2bbe5b53a2902.svg";